import { memo } from 'react';
import { Paper, ThemeIcon, Title, Stack, Text, Badge, Group } from '@mantine/core';
import { motion } from 'framer-motion';
import { IconTrophy, IconClock, IconRocket } from '@tabler/icons-react';

const podiumVariants = {
    hidden: { scale: 0.8, opacity: 0 },
    visible: { scale: 1, opacity: 1, transition: { type: "spring", bounce: 0.5 } }
};

/**
 * PodiumDisplay component displays the game state when no active question is present.
 * Shows trophies, countdowns, or the final podium results.
 */
const PodiumDisplay = memo(({ gameState, podium }) => (
    <Paper p="xl" withBorder bg="dark.6" ta="center">
        <motion.div variants={podiumVariants} initial="hidden" animate="visible" key={gameState}>
            <ThemeIcon size="xl" radius="xl" color={gameState === 'ended' ? (podium.length > 0 ? 'yellow' : 'red') : 'gray'} variant="light" mb="md">
                {gameState === "ended" ? <IconTrophy size={24} /> : gameState === "playing" ? <IconClock size={24} /> : <IconRocket size={24} />}
            </ThemeIcon>

            <Title order={3}>
                {gameState === "ended" ? (podium.length > 0 ? `Podium Reached!` : "Game Concluded")
                : gameState === "playing" ? "Get Ready..." : "Waiting for Host"}
            </Title>

            {gameState === "ended" && podium.length > 0 ? (
                <Stack gap="xs" mt="md">
                    <Text size="sm" c="dimmed" mb="xs">Top Bots in Your Session:</Text>
                    {podium.map((p, index) => {
                        const medalColor = p.rank === 1 ? 'yellow' : p.rank === 2 ? 'gray' : 'orange';
                        return (
                            <motion.div key={p.botName} initial={{ opacity: 0, x: -20 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: index * 0.2 }}>
                                <Paper p="xs" bg="dark.7" shadow="sm" withBorder style={{ borderColor: p.rank === 1 ? 'gold' : 'transparent' }}>
                                    <Group justify="space-between">
                                        <Group>
                                            <Badge color={medalColor} variant="filled" size="lg">#{p.rank}</Badge>
                                            <Text fw={700}>{p.botName}</Text>
                                        </Group>
                                        <Text c="dimmed" size="sm">{p.score} pts</Text>
                                    </Group>
                                </Paper>
                            </motion.div>
                        )
                    })}
                </Stack>
            ) : (
                <Text size="sm" c="dimmed" mt="sm">
                    {gameState === "ended" ? "The host has ended the game."
                    : gameState === "playing" ? "Waiting for the next question to start."
                    : "Hold tight, we're waiting for the game to begin."}
                </Text>
            )}
        </motion.div>
    </Paper>
));

export default PodiumDisplay;
